<template>
	<div class="widget">
		<div class="text-wrapper">
			<div
				v-if="pillProps?.label"
				class="widget-pill-wrapper"
			>
				<Pill
					v-if="pillProps?.label"
					:label="pillProps.label"
					:status="pillProps.status"
					:pillNoBackgroundColor="pillProps.pillNoBackgroundColor"
				/>
			</div>

			<div class="title-pill-wrapper">
				<div class="title-icon-wrapper">
					<div
						v-if="customIcon || svgIcon"
						class="icon"
					>
						<img
							v-if="svgIcon"
							:src="svgIcon"
							class="widget-image"
						/>
						<i
							v-if="customIcon"
							:class="getIconClass"
							:style="{ color: customIconColor }"
						></i>
					</div>
					<h3 class="title">
						{{ title }}
					</h3>
				</div>
			</div>
			<p class="widget-subtext">{{ subtext }}</p>
		</div>

		<div
			v-if="buttonProps?.buttonText"
			class="button-wrapper"
		>
			<PrimaryButton
				:buttonText="buttonProps?.buttonText"
				:clickAction="buttonProps?.clickAction"
				:isButtonDisabled="buttonProps?.isButtonDisabled"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed, toRefs } from 'vue';
	import Pill, { IPillProps } from '@core/components/Pill.vue';
	import PrimaryButton, { IButtonProps } from '@core/components/customerPortal/PrimaryButton.vue';

	export interface IWidgetProps {
		title?: string;
		subtext?: string;
		customIcon?: string;
		svgIcon?: string;
		customIconColor?: string;

		buttonProps?: IButtonProps;
		pillProps?: IPillProps;
	}

	const props = defineProps<IWidgetProps>();
	const { title, subtext, customIcon, svgIcon, customIconColor, buttonProps, pillProps } = toRefs(props);

	const getIconClass = computed(() => `widget-icon ${customIcon.value}`);
</script>
<style scoped>
	.widget {
		height: 200px;
		width: 100%;
		max-width: 720px;
		background-color: var(--customer-portal-off-white-color);
		border-radius: 9px;
		padding: 25px;
		box-shadow:
			0 20px 25px -5px rgba(0, 0, 0, 0.1),
			0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
	}

	.widget-pill-wrapper {
		z-index: 1;
		margin-top: -16px;
		display: flex;
		justify-content: flex-end;
	}

	.title-pill-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.title-icon-wrapper {
		margin-bottom: 10px;
		display: flex;
		align-items: center;
	}

	.title {
		font-size: clamp(14px, 5vw, 24px);
		color: var(--customer-portal-dark-gray-color);
	}

	.icon {
		margin-right: 10px;
		width: clamp(30px, 7vw, 41px);
		border-radius: 3px;
		display: flex;
		justify-content: center;
		padding: clamp(4px, 2vw, 7px);
	}

	.widget-image {
		width: 25px;
	}

	.text-wrapper {
		max-height: 108px;
		display: flex;
		flex-direction: column;
	}

	.widget-subtext {
		width: 100%;
		margin-top: 5px;
		margin-bottom: 15px;
		color: var(--customer-portal-secondary-text-color);
		font-weight: 400;
		font-size: clamp(12px, 3vw, 14px);
		@media screen and (min-width: 533px) {
			width: 68%;
		}
	}

	.button-wrapper {
		display: flex;
		justify-content: flex-end;
	}

	.widget-container {
		min-height: 236px;
		min-width: 400px;
		background: var(--customer-portal-white-color);
		background: linear-gradient(70deg, rgba(255, 255, 255, 1) 0%, rgba(177, 217, 238, 1) 8%, rgba(98, 179, 221, 1) 38%, rgba(31, 92, 255, 1) 83%);
		border-radius: 20px;
		box-shadow: 25px 25px 40px 0px rgba(0, 0, 0, 0.33);
		color: var(--customer-portal-white-color);
		overflow: hidden;
		position: relative;
	}
	.widget-icon {
		font-size: clamp(14px, 5vw, 25px);
		color: var(--customer-portal-secondary-color);
	}
</style>
